/**
 * Bildschirm 3 von 3 — „Suchen".
 *
 * Die Suchanfrage steht in der URL, nicht im Komponentenzustand: Ein Treffer,
 * den man jemandem schickt, muss beim Empfänger dieselbe Liste zeigen.
 *
 * In M0b sucht sie nichts. Der Volltextindex entsteht mit M5.
 */

import { useNavigate, useSearch } from '@tanstack/react-router'

import { EmptyState } from '@/components/states/EmptyState'

export function Search() {
  const { q } = useSearch({ from: '/suchen' })
  const navigate = useNavigate({ from: '/suchen' })

  return (
    <section aria-labelledby="search-heading" data-testid="screen-search">
      <header className="border-border flex h-(--row-h) items-center border-b px-(--page-x)">
        <h1 id="search-heading" className="text-page font-(--font-weight-page)">
          Suchen
        </h1>
      </header>

      <div className="border-border border-b px-(--page-x) py-2">
        <label htmlFor="search-input" className="sr-only">
          Suchbegriff
        </label>
        <input
          id="search-input"
          type="search"
          value={q}
          data-testid="search-input"
          placeholder="Objekt, Mieter, Vertrag oder Dokument"
          onChange={(event) => {
            void navigate({ search: { q: event.target.value }, replace: true })
          }}
          className="border-border bg-surface text-body placeholder:text-muted focus-visible:border-accent w-full rounded-card border px-3 transition-colors duration-(--duration-fast) ease-(--ease-out)"
        />
      </div>

      <EmptyState
        testId="search-empty"
        title={q === '' ? 'Tippe, um zu suchen.' : 'Keine Treffer.'}
        hint={
          q === ''
            ? 'Die Suche findet Objekte, Mieter, Verträge und Dokumente.'
            : 'Prüfe die Schreibweise oder suche nach einem Teil des Namens.'
        }
      />
    </section>
  )
}
